<script>
export default {
    data () {
        return {};
    },

    listeners: {
        'contacts-updated' () {
            window.location.reload();
        },

        'open-delete-modal' () {
            this.$refs.deleteModal.show();
        },
    },

    methods: {
        onDeleteSuccess (responseData) {
            window.location = responseData.redirectUrl;
        },
    },
};
</script>
